import {yup} from 'libs/yup'
import {FileFormType} from 'libs/formatter'

export const schema = yup.object({
  attachments: yup
    .array(
      yup.object({
        id: yup.string().notRequired(),
        file: yup.mixed<FileFormType | File>().required().file().fileSize().label('添付ファイル'),
      })
    )
    .required()
    .max(10, ({label}) => `${label}にアップロードできるファイルは10件までです`)
    .label('添付ファイル'),
})

export type Schema = yup.InferType<typeof schema>
